import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { IUserData } from '@app/modules/auth/interfaces/user-data.interface';
import { AuthApiService } from '@app/modules/auth/services/auth-api/auth-api.service';
import { SupportApiService } from '@app/modules/admin/services/support-api.service';
import { NotificationService } from '@app/core/services/infrastructure/notification/notification.service';

@Component({
    selector: 'app-support-request-dialog',
    templateUrl: './support-request-dialog.component.html',
    styleUrl: './support-request-dialog.component.scss',
    standalone: false,
})
export class SupportRequestDialogComponent implements OnInit {
    supportForm: FormGroup;
    isLoading = false;
    user: IUserData | null = null;

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<SupportRequestDialogComponent>,
        private authService: AuthApiService,
        private supportApiService: SupportApiService,
        private notificationService: NotificationService
    ) {
        this.supportForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            name: ['', [Validators.maxLength(100)]],
            subject: ['', [Validators.required, Validators.maxLength(100)]],
            message: ['', [Validators.required, Validators.maxLength(1000)]],
        });
    }

    ngOnInit(): void {
        // Get current user if authenticated
        this.authService.user$.subscribe((user) => {
            this.user = user;
            if (user) {
                // Pre-fill email and name if user is authenticated
                this.supportForm.patchValue({
                    email: user.email,
                    name: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName || '',
                });
            }
        });
    }

    onSubmit(): void {
        if (this.supportForm.invalid) {
            this.supportForm.markAllAsTouched();
            return;
        }

        this.isLoading = true;
        const formValue = this.supportForm.value;

        this.supportApiService.createSupportRequest(formValue).subscribe({
            next: () => {
                this.notificationService.info('support.request.success');
                this.dialogRef.close(true);
                this.isLoading = false;
            },
            error: () => {
                this.notificationService.error('support.request.error');
                this.isLoading = false;
            },
        });
    }

    close(): void {
        this.dialogRef.close();
    }
}
